import React from 'react';
import { Formik } from 'formik';

// Import helpers
import validation from './validate';

// Import components
import LoginFormFields from './LoginFormFields';

// Import logic
import useLoginForm from './useLoginForm';

const LoginForm = () => {
	const { formRef, initialValues, authError, submit } = useLoginForm();

	return (
		<Formik
			ref={formRef}
			initialValues={initialValues}
			validate={validation}
			onSubmit={submit}
		>
			{({ handleSubmit, isSubmitting }) => (
				<form data-testid="login-form" onSubmit={handleSubmit}>
					<LoginFormFields isSubmitting={isSubmitting} authError={authError} />
				</form>
			)}
		</Formik>
	);
};

export default LoginForm;
